module.exports = __webpack_public_path__ + "static/img/smith-farm-historical-signs03.30d1362.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/smith-farm/smith-farm-historical-signs03.jpg
// module id = 958
// module chunks = 0